import React, { useState } from 'react';
import Container from '@components/ui-old/container';
import Layout from '@components/layout/layout';
import PageHeader from '@components/ui-old/page-header';
import ContactForm from '@components/common/form/contact-form';
import ContactInfoBlock from '@containers/contact-info';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { GetStaticProps } from 'next';
import ModernGoogleMap from '@components/other/modern-contact-map';
import { getCurrentLocationAndLanguage } from '@utils/location';
import { NextSeo } from 'next-seo';
import { siteSettings } from '@settings/site-settings';
interface MapInfo {
  companyName: string;
  address: string;
  mapQuery: string;
  visitUsUrl: string;
}
interface MapsData {
  tr: MapInfo[];
  uz: MapInfo[];
  kg: MapInfo[];
  kz: MapInfo[];
  ge: MapInfo[];
  az: MapInfo[];
  iq: MapInfo[];
}
type LocationKey = keyof MapsData;
export default function ContactUsPage() {
  const {
    t
  } = useTranslation('common');
  const {
    location
  } = getCurrentLocationAndLanguage();
  const mapsData: MapsData = {
    uz: [{
      companyName: "Forever Product Bek LLC",
      address: t('footer:text-tashkent-address'),
      mapQuery: "GLINKA+STREET+40+YAKKASARAY+DISTRICT+100070+TASHKENT+CITY,+UZBEKISTAN",
      visitUsUrl: 'https://maps.app.goo.gl/CUnjpWygBQv373AS7'
    }],
    tr: [{
      companyName: "Forever Living Products Turkey - İstanbul",
      address: "Gazeteciler Sitesi Yazarlar Sokak No:8 Esentepe Mahallesi Şişli/ İstanbul",
      mapQuery: "Gazeteciler+Sitesi+Yazarlar+Sokak+No:8+Esentepe+Mahallesi+Şişli+İstanbul",
      visitUsUrl: 'https://maps.app.goo.gl/qn8h16wnEgcevTbd6'
    }, {
      companyName: "Forever Living Products Turkey - İzmir",
      address: "İsmet Kaptan Mahallesi 1371 Sokak No.3/A, Çankaya - Konak / İzmir",
      mapQuery: "Ismet+Kaptan+Mahallesi+1371+Sokak+3/A+Çankaya+Konak+Izmir",
      visitUsUrl: 'https://maps.app.goo.gl/YDEPrrcpaRMQEoiB8'
    }],
    kg: [{
      companyName: "Форевер Ливинг Продактс Кыргызстан",
      address: t('footer:text-bishkek-address'),
      mapQuery: "Bishkek+Razzakov+str+33-2+Bishkek+kyrgyzstan",
      visitUsUrl: 'https://goo.gl/maps/bpwfdSksBDuD7CHk7'
    }
    // {
    //   companyName: "Forever Living Products Kyrgyzstan - Osh",
    //   address: "prospect Masaliev 39 Osh, Kyrgyzstan",
    //   mapQuery: "prospect+Masaliev+39+Osh+kyrgyzstan",
    //   visitUsUrl: 'https://maps.app.goo.gl/JKswAH3rmhcJui7i7',
    // },
    ],
    kz: [{
      companyName: "Forever Living Prodakts Kazakhstan - Almaty",
      address: "M-N Zhetysu 2, No. 15 A, Street Saina Corner Street, Ulugbek St, Almaty 050063, Kazakistan",
      mapQuery: "6RGW+C8 Almatı, Kazakistan",
      visitUsUrl: 'https://goo.gl/maps/Uixjb6cRvUT2hbiY9'
    }, {
      companyName: "Forever Living Prodakts Kazakhstan - Astana",
      address: "Shokan Valikhanov Street 12, Astana 010000, Kazakistan",
      mapQuery: "5C9R+G3 Astana, Kazakistan",
      visitUsUrl: 'https://go.2gis.com/O0Fst'
    }, {
      companyName: "Forever Living Prodakts Kazakhstan - Atyrau",
      address: "Atyrau, Avangard 2-nd m-district, House 11-B, Block 4, groud floor, place #3 (Modern Stroi)",
      mapQuery: "3VXH+C9 Atırav, Kazakistan",
      visitUsUrl: 'https://maps.app.goo.gl/De8H5iGYieeVcftP7'
    }],
    ge: [{
      companyName: "Forever Living Products Georgia",
      address: t('footer:text-tblisi-address'),
      mapQuery: "27g+Adam+Mitskevichi+St,+Tbilisi+Gürcistan",
      visitUsUrl: 'https://maps.app.goo.gl/FNXvvg2DvyDBgscS6'
    }],
    az: [{
      companyName: "Forever Living Products Azərbaycan MMC",
      address: t('footer:text-baku-address'),
      mapQuery: "CR3R+WRJ, Baku, Azerbaycan",
      visitUsUrl: 'https://goo.gl/maps/59Y9BsudgUpUL6g47'
    }],
    iq: [{
      companyName: "Forever Living Products Iraq",
      address: "Zaniari District No:30/89 Behind the First Erbil Tower (Francois Hariri Stadium) Erbil, Iraq",
      mapQuery: "52G5+WG8 Erbil, Irak",
      visitUsUrl: 'https://maps.app.goo.gl/AjNK34PsFNgJMZTf8'
    }]
  };
  const locationKey = location as LocationKey;
  const [selectedLocationIndex, setSelectedLocationIndex] = useState<number>(0);
  const selectedMapData = mapsData[locationKey]?.[selectedLocationIndex] || null;
  return <>
     <NextSeo title={`${t('menu:menu-forever-contact') || "Contact Us"} - ${siteSettings.name}`} description={t('common:text-contact-description') || "Get in contact with us"} canonical={`${siteSettings.author.websiteUrl}forever/contact-us`} openGraph={{
      url: `${siteSettings.author.websiteUrl}forever/contact-us`,
      title: `${t('menu:menu-forever-contact') || "Contact Us"} - ${siteSettings.name}`,
      description: t('common:text-contact-description') || "Get in contact with us",
      images: [{
        url: `${siteSettings.author.websiteUrl}assets/images/og-image-01.png`,
        width: 1200,
        height: 630,
        alt: `${t("menu:menu-forever-contact")}`
      }],
      site_name: siteSettings.name
    }} twitter={{
      handle: "@handle",
      site: "@site",
      cardType: "summary_large_image"
    }} data-sentry-element="NextSeo" data-sentry-source-file="contact-us.tsx" />
      <PageHeader pageHeader="text-page-contact-us" data-sentry-element="PageHeader" data-sentry-source-file="contact-us.tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="contact-us.tsx">
        <div className="my-14 lg:my-16 xl:my-20 px-0 pb-2 lg: xl:max-w-screen-xl mx-auto flex flex-col md:flex-row w-full">
          <div className="md:w-full lg:w-2/5 2xl:w-2/6 flex flex-col h-full">
            <ContactInfoBlock selectedLocationIndex={selectedLocationIndex} setSelectedLocationIndex={setSelectedLocationIndex} data-sentry-element="ContactInfoBlock" data-sentry-source-file="contact-us.tsx" />
          </div>
          <div className="md:w-full lg:w-3/5 2xl:w-4/6 flex h-full ltr:md:ml-7 rtl:md:mr-7 flex-col ltr:lg:pl-7 rtl:lg:pr-7 border border-neutral-200 dark:border-neutral-800 p-6 rounded-lg shadow-md">
            <div className="flex pb-7 md:pb-9 mt-7 md:-mt-1.5">
              <h4 className="text-2xl 2xl:text-3xl font-bold text-heading dark:text-neutral-200">
                {t('text-get-in-touch')}
              </h4>
            </div>
            <ContactForm data-sentry-element="ContactForm" data-sentry-source-file="contact-us.tsx" />
          </div>
        </div>
        <div className="mb-12">
          {selectedMapData && <ModernGoogleMap key={selectedLocationIndex} companyName={selectedMapData.companyName} address={selectedMapData.address} mapQuery={selectedMapData.mapQuery} visitUsUrl={selectedMapData.visitUsUrl} />}
        </div>
      </Container>
    </>;
}
ContactUsPage.Layout = Layout;
export const getStaticProps: GetStaticProps = async ({
  locale
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale!, ['common', 'forms', 'menu', 'footer', 'swal']))
    }
  };
};